import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import Icon from './icon_cloud.svg';
import s from './index.module.scss';

export const ExportButton = ({ className }) => {
  const { t } = useTranslation('reports');
  const { openSingleModal } = useModal();

  return (
    <button
      type="button"
      onClick={() => openSingleModal(MODAL_IDS.report_download_modal)}
      className={classnames(s.button, className)}
    >
      <img src={Icon} alt="export" width={20} height={20} />
      <span>{t('export_button.export')}</span>
    </button>
  );
};
